<template>
    <v-dialog v-model="dialog" width="800px">
        <v-card>
            <v-card-title class="justify-center">Agent scale calculation</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-row dense>
                    <v-col cols=1 class="font-weight-bold">Agent</v-col> 
                    <v-col cols=3>{{ scale.agent_name }}</v-col> 
                </v-row>
                <v-row dense>
                    <v-col cols=1 class="font-weight-bold">Acco</v-col> 
                    <v-col cols=3>{{ scale.acco }}</v-col> 
                </v-row>
                <v-row dense>
                    <v-col cols=1 class="font-weight-bold">Period</v-col> 
                    <v-col cols=7>{{ scale.year }}</v-col> 
                </v-row>
                <v-row dense>
                    <v-col cols=1 class="font-weight-bold">Scale</v-col> 
                    <v-col cols=1>1</v-col> 
                    <v-col cols=1>2</v-col> 
                    <v-col cols=1>3</v-col> 
                    <v-col cols=1>4</v-col> 
                    <v-col cols=1>5</v-col> 
                    <v-col cols=6></v-col> 
                </v-row>
                <v-row dense>
                    <v-col cols=1 class="font-weight-bold">Perc.</v-col> 
                    <v-col cols=1>{{ scale.scale1 }}</v-col> 
                    <v-col cols=1>{{ scale.scale2 }}</v-col> 
                    <v-col cols=1>{{ scale.scale3 }}</v-col> 
                    <v-col cols=1>{{ scale.scale4 }}</v-col> 
                    <v-col cols=1>{{ scale.scale5 }}</v-col> 
                    <v-col cols=6></v-col> 
                </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-text v-if="scale.scaletype>1">
                <v-row dense>
                    <v-col cols=5 class="font-weight-bold">Period</v-col> 
                    <v-col cols=2 class="font-weight-bold text-right">Amount</v-col> 
                    <v-col cols=1 class="font-weight-bold text-right">Scale</v-col> 
                    <v-col cols=4 class="font-weight-bold"></v-col> 
                </v-row>                   
                <v-row dense>
                    <v-col cols=5>{{ scale.year2 }} (previous year)</v-col> 
                    <v-col cols=2 class="text-right">{{ scale.amount2 }}</v-col> 
                    <v-col cols=1 class="text-right">{{ scale.scaleyear2 }}</v-col> 
                    <v-col cols=4 ></v-col> 
                </v-row>                   
                <v-row dense>
                    <v-col cols=5>{{ scale.year1 }} (calculation period)</v-col> 
                    <v-col cols=2 class="text-right">{{ scale.amount1 }}</v-col> 
                    <v-col cols=1 class="text-right">{{ scale.scaleyear1 }}</v-col> 
                    <v-col cols=4></v-col> 
                </v-row>                   
            </v-card-text>
            <v-divider v-if="scale.scaletype>1"></v-divider>
            <v-card-text>
                <v-row dense v-if="scale.scaletype===1">
                    <v-col cols=12 class="pt-4">First contract year: commission scale = 1 for this period</v-col>
                </v-row>
                <v-row dense class="pt-2" v-if="scale.scaletype>5">
                    <v-col cols=7>Difference ({{ scale.amount1 }} - {{ scale.amount2 }})</v-col> 
                    <v-col cols=2 class="text-right">{{ scale.difference }}</v-col> 
                </v-row>   
                <v-row dense v-if="scale.scaletype>5">
                    <v-col cols=7>Difference percentage (100 * {{ scale.amount1 }} - {{ scale.amount2 }} / {{ scale.amount2 }})</v-col> 
                    <v-col cols=2 class="text-right">{{ scale.maginPerc }}</v-col> 
                </v-row>   
                <v-row dense v-if="scale.scaletype===2">
                    <v-col cols=12 class="pt-4" v-if="scale.scaleyear2 !== scale.scaleyear1">Negative amount for calculation period: Commision scale goes from {{ scale.scaleyear2 }} to {{ scale.scaleyear1 }}</v-col>
                    <v-col cols=12 class="pt-4" v-if="scale.scaleyear2 === scale.scaleyear1">Negative amount for calculation period: Commision scale stays {{ scale.scaleyear2 }}</v-col>
                </v-row>
                <v-row dense  v-if="scale.scaletype===3">
                    <v-col cols=12 class="pt-4" v-if="scale.scaleyear2 !== scale.scaleyear1">Negative amount for previous period: Commision scale goes from {{ scale.scaleyear2 }} to {{ scale.scaleyear1 }}</v-col>
                    <v-col cols=12 class="pt-4" v-if="scale.scaleyear2 === scale.scaleyear1">Negative amount for previous period: Commision scale stays {{ scale.scaleyear2 }}</v-col>
                </v-row>              
                <v-row dense  v-if="scale.scaletype===4">
                    <v-col cols=12 class="pt-4" v-if="scale.scaleyear2 !== scale.scaleyear1">0 amount for previous period: Commision scale goes from {{ scale.scaleyear2 }} to {{ scale.scaleyear1 }}</v-col>
                    <v-col cols=12 class="pt-4" v-if="scale.scaleyear2 === scale.scaleyear1">0 amount for previous period: Commision scale stays {{ scale.scaleyear2 }}</v-col>
                </v-row>              
                <v-row dense v-if="scale.scaletype===5">
                    <v-col cols=12 class="pt-4" v-if="scale.scaleyear2 !== scale.scaleyear1">Margin is lower: Commision scale goes from {{ scale.scaleyear2 }} to {{ scale.scaleyear1 }}</v-col>
                    <v-col cols=12 class="pt-4" v-if="scale.scaleyear2 === scale.scaleyear1">Margin is lower: Commision scale stays {{ scale.scaleyear2 }}</v-col>
                </v-row>                   
                <v-row dense v-if="scale.scaletype===6"> 
                    <v-col cols=12 class="pt-4" v-if="scale.scaleyear2 !== scale.scaleyear1">Margin percentage &lt; 5%: Commision scale goes from {{ scale.scaleyear2 }} to {{ scale.scaleyear1 }}</v-col>
                    <v-col cols=12 class="pt-4" v-if="scale.scaleyear2 === scale.scaleyear1">Margin percentage &lt; 5%: Commision scale stays {{ scale.scaleyear2 }}</v-col>
                </v-row>                   
                <v-row dense v-if="scale.scaletype===7">
                    <v-col cols=12 class="pt-4" v-if="scale.scaleyear2 !== scale.scaleyear1">Margin percentage between 5% and 10%: Commision scale goes from {{ scale.scaleyear2 }} to {{ scale.scaleyear1 }}</v-col>
                    <v-col cols=12 class="pt-4" v-if="scale.scaleyear2 === scale.scaleyear1">Margin percentage between 5% and 10%: Commision scale stays {{ scale.scaleyear2 }}</v-col>
                </v-row>                   
                <v-row dense v-if="scale.scaletype===8">
                    <v-col cols=12 class="pt-4" v-if="scale.scaleyear2 !== scale.scaleyear1">Margin percentage &gt;= 10%: Commision scale goes from {{ scale.scaleyear2 }} to {{ scale.scaleyear1 }}</v-col>
                    <v-col cols=12 class="pt-4" v-if="scale.scaleyear2 === scale.scaleyear1">Margin percentage &gt;= 10%: Commision scale stays {{ scale.scaleyear2 }}</v-col>
                </v-row>                   
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" small @click="dialog=false">Close</v-btn>
            </v-card-actions>
        </v-card> 
    </v-dialog>
</template>

<script>
    export default {
        components: {
        },
        data() {
            return {
                dialog: false,
                scale: {
                    agent_name: "",
                    year: 9999,
                },
            }
        },
        methods: { 
            openDialog(agent_encrid, hscj_encrid) {
                this.dialog = false;
                this.getAgentScaleCalculation(agent_encrid, hscj_encrid);
            },
            getAgentScaleCalculation(agent_encrid, hscj_encrid) {
                this.$axios.post("ares/json/ares/syst/agent/ovrz/getAgentScaleCalculation.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getAgentScaleCalculation",
                    },
                    getAgentScaleCalculation: {
                        agent_encrid: agent_encrid,
                        hscj_encrid: hscj_encrid
                    },
                }).then((res) => {
                    if (res.data.error) {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.scale = res.data.getAgentScaleCalculation;
                        this.dialog = true;
                    }
                });

            },
        }
    }
</script>

